import { Component } from '@angular/core';

@Component({
    selector: 'app-channel-table-header',
    templateUrl: './channel-table-header.component.html',
    styleUrls: ['./channel-table-header.component.scss'],
    standalone: false
})
export class ChannelTableHeaderComponent {}
